export default __webpack_public_path__ + "static/media/FIN-TECH-IMG.84368eb0.gif";